import { h, Fragment } from 'preact';
import Image from 'utils/image';

const Features = ({ currentVariant }) => (
  <>
    {currentVariant.features.length > 0 && (
      <div className="text-primary">
        <h3 className="body-14-med md:body-16-med mb-15 lg:mb-20">{window.TMW.Strings.product.keyFeatures}</h3>
        <ul className="lg:gap-10 m-0 flex flex-wrap gap-6 p-0">
          {currentVariant.features.map((feature, index) => (
            <li
              key={index}
              className="flex min-w-[110px] flex-grow flex-col items-center gap-4 rounded bg-grey-6 p-8 lg:px-20 lg:py-15"
            >
              <Image
                src={feature.icon}
                srcWidths={{ sm: 100 }}
                height="50"
                width="50"
                alt={`${feature.title} image`}
              />
              <span className="body-12-med body-14-med">{feature.title}</span>
            </li>
          ))}
        </ul>
      </div>
    )}
  </>
);

export default Features;
